import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

export function recordActivity(event: string, success: boolean, message: string) {
  const call = httpsCallable(functions, "recordAdminActivity");
  return call({ event, success, message }).catch((error) => {
    console.error("Could not record activity", error);
  });
}
